// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
import Select, { components } from "react-select";
import { toggle_off, toggle_on } from "../../../assets/img";
import DocDragAndDrop from "../../Property/DocDragAndDrop";
import { URLS } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import OverallDocDragAndDrop from "../../Property/OverallDocDragAndDrop";
import DragAndDrop from "../../Property/DragAndDrop";
import { checkPermission } from "../../../screen/redux/api/PermissionManager";

const Document = ({ setTabs }) => {
  const isUploading = useRef(false);
  const [addPopup, setAddPopup] = useState(false);
  const [gstName, setGstName] = useState();
  const [errors, setErrors] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState([]);
  const [draggableImages, setDraggableImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [policy, setPolicy] = useState("");
  const [receptionist, setReceptionist] = useState("");
  const [text, setText] = useState([]);
  const [popUpData, setPopupData] = useState({
    name: "",
    image: "",
  });
  const [receptionistOptions, setReceptionistOptions] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const [type, setType] = useState("view");
  const id = location?.state?.id;
  const owner_id = location?.state?.owner;
  console.log("typeDoc", type);
  console.log("owner_id", owner_id);
  const [selectedReceptionists, setSelectedReceptionists] = useState([]);

  useEffect(() => {
    getReceptionist();
    viewProperty();
  }, []);

  const viewProperty = async () => {
    const res = await get(URLS.PROPERTY_MASTER + id);
    console.log("view property", res);
    if (res?.status === "success") {
      let { documents, images, details } = res?.data;
      let images_arr = [];
      images?.map((item) => {
        if (item?.type === 2) {
          images_arr.push({ ...item, image: item?.image_name });
        }
      });
      console.log("images array", images_arr, images);
      let document_arr = documents?.map((item) => ({
        name: item?.doc_name,
        image: item?.doc_file_name,
      }));
      let receptionistsList = res?.data?.receptionists?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));
      setSelectedReceptionists(receptionistsList);
      setReceptionist(receptionistsList?.length !== 0);
      setDraggableImages(images_arr);
      setSelectedImage(document_arr);
      setText(details?.additional_texts || []);
    }
  };
  console.log(
    "console.log",
    draggableImages,
    selectedImage,
    selectedReceptionists
  );
  const handleChange = (selected) => {
    setSelectedReceptionists(selected || []);
  };

  // Custom Option with Radio Button
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          key={props.value}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{props.label}</span>
          <div className="">
            <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
              ID: {props.data?.code}
            </span>
            <button
              style={{
                marginLeft: "auto",
                height: "16px",
                width: "16px",
                borderRadius: "50%",
                border: "2px solid #9A36E6",
                display: "inline-block",
                position: "relative",
              }}
            >
              {props.isSelected && (
                <span
                  style={{
                    height: "8px",
                    width: "8px",
                    backgroundColor: "#9A36E6",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              )}
            </button>
          </div>
        </div>
      </components.Option>
    );
  };
  const handleRemove = (value) => {
    setSelectedReceptionists((prev) =>
      prev.filter((item) => item.value !== value)
    );
  };

  const CustomMultiValue = () => null;

  const handleImageClick = () => {
    inputRef.current.click();
  };

  const editDocHandler = (index, file) => {
    // setType("edit");
    setAddPopup(true);
    setGstName("GST Document");
    setPopupData({
      name: file?.name,
      image: file?.image,
    });
  };

  const handleAddText = () => {
    setText((prev) => [...prev, { title: "", description: "" }]); // append new policy to array
  };
  const handleChangeText = (index, value) => {
    setText((prev) => prev.map((item, i) => (i === index ? value : item)));
  };
  const handleTextDelete = (index) => {
    setText((prev) => prev.filter((_, i) => i !== index));
  };

  const getReceptionist = async () => {
    const res = await get(URLS.RECEPTIONIST_OVERALL + owner_id + "/");
    console.log("receptionist res", res);
    if (res?.status === "success") {
      let tempList = res?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));
      setReceptionistOptions(tempList);
    }
  };

  const handleSubmit = async () => {
    if (!popUpData?.name) {
      toast.error("Enter GST Name");
      return;
    }
    if (!popUpData?.image) {
      toast.error("Enter Document");
      return;
    } else {
      const payload = new FormData();
      payload.append("doc_name", popUpData?.name);
      payload.append("doc_file", popUpData?.image);
      const res = await post(
        URLS.PROPERTY_MASTER + id + "/documents/upload/",
        payload
      );
      console.log("document upload", res);
      if (res?.status === "success") {
        let temp = [...selectedImage, popUpData];
        setSelectedImage(temp);
        onReset();
        setErrors(false);
        setAddPopup(false);
      }
    }
  };

  const onReset = () => {
    setPopupData({
      name: "",
      image: "",
    });
  };

  const addDocHandler = () => {
    setGstName(""); // Reset GST Name
    setAddPopup(true); // Open popup
  };

  const handleFimalSubmit = async () => {
    if (isUploading.current) {
      return;
    }
    isUploading.current = true;
    if (
      text.length === 0 &&
      draggableImages.length === 0 &&
      selectedImage.length === 0
    ) {
      toast.error("Please upload any one of the Feild...");
      return;
    }
    const payload = new FormData();
    payload.append("additional_texts", JSON.stringify(text));
    payload.append(
      "receptionist_ids",
      receptionist
        ? JSON.stringify(selectedReceptionists?.map((item) => item.value))
        : []
    );

    let positions_list = [];
    draggableImages?.forEach((img, ind) => {
      payload.append("property_images", img?.image);
      positions_list.push(ind + 1);
    });

    payload.append("deleted_image_ids", deletedImages);
    payload.append("property_images_position", JSON.stringify(positions_list));
    console.log("payload", payload);
    const res = await post(
      URLS.PROPERTY_MASTER + id + "/documents/upload/",
      payload
    );
    console.log("docement upload", res);
    if (res?.status === "success") {
      isUploading.current = false;
      setType("view");
      toast.success(res?.message);
      viewProperty();
    }
  };

  return (
    <div>
      <div>
        {checkPermission("CAN-EDIT-OVERALL_PROPERTIES") && (
          <div className="d-flex ac-je">
            {type != "edit" ? (
              <button
                onClick={() => setType("edit")}
                className="add-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                Edit
              </button>
            ) : (
              <button
                onClick={() => setType("view")}
                className="add-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                Cancel
              </button>
            )}
          </div>
        )}

        {type == "edit" && (
          <p
            onClick={() => {
              addDocHandler();
            }}
            className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 green my-4 pointer"
          >
            +Add Document
          </p>
        )}
        {selectedImage?.length != 0 && (
          <div
            className="d-flex flex-wrap gap-5 pb-5"
            style={{ borderBottom: "2px solid #D9D9D9" }}
          >
            {selectedImage?.map((file, index) => (
              <div key={index} className="col-md-5">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  {file?.name}
                </p>
                <p
                  onClick={() => editDocHandler(index, file)}
                  className="doc-input pointer"
                >
                  {typeof file?.image === "string"
                    ? file?.name + ".pdf"
                    : file?.image?.name}
                </p>
              </div>
            ))}
          </div>
        )}

        <div
          style={{
            borderBottom: "2px solid #D9D9D9",
            paddingBottom: "20px",
            marginTop: "20px",
          }}
        >
          <DragAndDrop
            edit={type !== "view"}
            draggableImages={draggableImages}
            setDraggableImages={setDraggableImages}
            setDeletedImages={setDeletedImages}
          />
        </div>
        {type == "edit" && (
          <p
            onClick={() => {
              handleAddText();
            }}
            className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer"
          >
            <span className="green">+Add Text </span>(Optional)
          </p>
        )}
        <div className="">
          {text.map((item, ind) => {
            return (
              <div className="w-100 mt-5">
                <div className="d-flex ac-jb">
                  <input
                    className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 gray input-border w-30 "
                    placeholder="Text"
                    value={item?.title}
                    onChange={(e) => {
                      handleChangeText(ind, { ...item, title: e.target.value });
                    }}
                  />
                  {type == "edit" && (
                    <CloseSharpIcon
                      onClick={() => handleTextDelete(ind)}
                      className="pointer gray"
                    />
                  )}
                </div>
                <div className="d-flex ae-jb input-border p-1">
                  <textarea
                    style={{ maxHeight: "100px" }}
                    value={item?.description}
                    onChange={(e) => {
                      handleChangeText(ind, {
                        ...item,
                        description: e.target.value,
                      });
                    }}
                    placeholder="Write Here...."
                    className="border-0 mb-3 w-100"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex ac-js gap-3 mt-5">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Receptionist
          </p>
          <button className="cust-btn">
            <img
              onClick={() => {
                if (receptionistOptions.length === 0) {
                  toast.error("No Receptionist Available");
                  return;
                }
                if (type === "edit") setReceptionist(!receptionist);
              }}
              src={receptionist ? toggle_on : toggle_off}
              className="roles-icon pointer"
              alt=""
            />
          </button>
        </div>
        {receptionist && (
          <div className={" mb-5  col-md-4 "}>
            <p className=" f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 sec mt-4">
              Add Receptionist
            </p>

            <div>
              <Select
                options={receptionistOptions}
                value={selectedReceptionists}
                onChange={handleChange}
                placeholder="Select Receptionist"
                isMulti
                isSearchable
                isClearable={false}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isDisabled={type !== "edit"}
                components={{
                  Option: CustomOption,
                  MultiValue: CustomMultiValue, // hides inside select
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#ccc",
                    minHeight: "40px",
                  }),
                }}
              />

              {/* Selected items OUTSIDE the select box */}
              {selectedReceptionists.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  {selectedReceptionists.map((person) => (
                    <div
                      key={person.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "6px",
                        padding: "6px 10px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    >
                      <span>{person.label}</span>
                      <div className="">
                        <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
                          ID: {person.code}
                        </span>
                        <button
                          onClick={() => {
                            if (type === "edit") handleRemove(person.value);
                          }}
                          style={{
                            marginLeft: "auto",
                            height: "16px",
                            width: "16px",
                            borderRadius: "50%",
                            border: "2px solid #9A36E6",
                            display: "inline-block",
                            position: "relative",
                          }}
                        >
                          <span
                            style={{
                              height: "8px",
                              width: "8px",
                              backgroundColor: "#9A36E6",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {addPopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <div className="d-flex ac-je">
                <CloseSharpIcon
                  onClick={() => {
                    setAddPopup(false);
                    onReset();
                    setErrors("");
                  }}
                  className="pointer"
                />
              </div>
              <div className="">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                  Name
                </p>
                <input
                  className="doc-input"
                  name="email"
                  value={popUpData?.name}
                  onChange={(e) =>
                    setPopupData((pre) => ({ ...pre, name: e.target.value }))
                  }
                  type="text"
                  placeholder="GST Document"
                />
              </div>
              <div className="d-flex ae-jb px-2 mt-4">
                <div className="w-60">
                  <div className=" w-100 d-flex ac-jb">
                    <div className="position-relative w-100">
                      <div className=" w-100">
                        <div>
                          {console.log("sssss", selectedImage)}

                          <div className="d-flex ae-js gap-1">
                            <p
                              className="bg-gray1 white rounded d-flex ac-jc"
                              style={{ height: "50px", width: "60%" }}
                            >
                              {typeof popUpData?.image === "string"
                                ? popUpData?.name + ".pdf"
                                : popUpData?.image?.name
                                ? popUpData?.image?.name
                                : "No file chosen"}
                            </p>
                            {popUpData?.image && (
                              <button
                                className="view-btn d-flex gap-2 mt-1 "
                                onClick={() =>
                                  window.open(
                                    typeof popUpData?.image === "string"
                                      ? popUpData?.image
                                      : URL.createObjectURL(popUpData?.image)
                                  )
                                }
                              >
                                View
                              </button>
                            )}
                          </div>
                          <input
                            style={{
                              position: "absolute",
                              width: "100px",
                              height: "100px",
                              left: "0px",
                              top: "0px",
                            }}
                            type="file"
                            hidden
                            name="myImage"
                            accept="application/pdf"
                            ref={inputRef}
                            onChange={(e) =>
                              setPopupData((pre) => ({
                                ...pre,
                                image: e.target.files[0],
                              }))
                            }
                          />
                          <button
                            className="submit-btn d-flex gap-2 mt-1 "
                            onClick={handleImageClick}
                          >
                            <CloudUploadRoundedIcon /> Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => {
                    handleSubmit();
                    // logout();
                  }}
                  className="submit-btn f2 w-40"
                >
                  {/* {loading ? "Loading..." : "Confirm"}  {type == "edit" ? "Submit" : "Add"} */}
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex ac-jb mt-4">
        <button
          onClick={() => setTabs(1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 w-30"
        >
          Back
        </button>
        {type === "edit" && (
          <button
            onClick={handleFimalSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
          >
            Submit
          </button>
        )}
      </div>
    </div>
  );
};

export default Document;
